import type {
  AbnArm,
  AbnArmResponse,
  AbnExperiment,
  AbnExperimentResponse,
  AbnHistoryEntry,
  AbnHistoryMapResponse,
  AbnInstance,
  AbnInstanceExperiments,
  AbnInstanceExperimentsResponse,
  AbnInstanceResponse,
  AbnVariationTranslations,
  AbnVariationTranslationsResponse,
} from '../types';

function toTimestamp(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function mapAbnHistory(map: AbnHistoryMapResponse): AbnHistoryEntry[] {
  if (!map) return [];
  return Object.entries(map)
    .map(([startedAt, endedAt]) => ({ startedAt: toTimestamp(startedAt), endedAt: toTimestamp(endedAt) }))
    .sort((a, b) => (b.startedAt ?? 0) - (a.startedAt ?? 0));
}

export function mapAbnInstance(data: AbnInstanceResponse): AbnInstance {
  return {
    name: data.name,
    isActive: data.is_active,
  };
}

export function mapAbnArm(data: AbnArmResponse): AbnArm {
  return {
    id: data.id,
    name: data.name,
    data: data.data,
  };
}

export function mapAbnExperiment(data: AbnExperimentResponse): AbnExperiment {
  return {
    id: data.id,
    name: data.name,
    control: mapAbnArm(data.control),
    variations: (data.variations ?? []).map(mapAbnArm),
    splits: data.splits?.length ? data.splits : null,
    createdAt: data.created_at,
    activatedAt: data.activated_at,
    activationHistory: mapAbnHistory(data.activated_deactivated_at_map),
    archiveHistory: mapAbnHistory(data.archived_unarchived_at_map),
  };
}

export function mapAbnInstanceExperiments(data: AbnInstanceExperimentsResponse): AbnInstanceExperiments {
  return {
    template: data.template,
    activeExperiment: data.active_experiment ? mapAbnExperiment(data.active_experiment) : null,
    experiments: (data.experiments ?? []).filter(Boolean).map(mapAbnExperiment),
  };
}

export function mapAbnVariationTranslations(data: AbnVariationTranslationsResponse): AbnVariationTranslations {
  return {
    translationsMap: data.translations_map ?? null,
    addedLocales: data.added_locales ?? [],
  };
}
